// extracted by mini-css-extract-plugin
export var container = "_eh-1";
export var editor = "_eh-2";
export var resizable = "_eh-3";
export var wrapper = "_eh-0";